<template>
  <el-card>
    <div slot="header" class="clearfix">
      <span class="ch-card-title">联系方式</span>
    </div>
    <div class="ch-box">

      <div class="ch-item" v-for="(item, index) in list" :key="index">
        <div class="ch-icon">
          <el-image :src="item.icon" />
        </div>
        <div class="ch-content">
          <div class="ch-label">{{ item.label }}</div>
          <div class="ch-value" :class="item.class">
            <div>{{ item.value }}</div>
          </div>
        </div>
      </div>

    </div>
  </el-card>
</template>

<script>
import Imaes from '../../assets/images'
import announcement from "@/api/announcement/announcement"
export default {
  created() {
    setTimeout(() => {
      this.list[0].value = JSON.parse(localStorage.getItem('orgInfo')).contactPhone
      this.list[1].value = JSON.parse(localStorage.getItem('orgInfo')).email
    }, 500);
  },
  data() {
    return {
      wechat: {
        icon: Imaes.wechat,
        label: '微信',
        value: ["13667895788", "18845698969"],
        class: ''
      },
      list: [
        {
          icon: Imaes.tel,
          label: '服务热线',
          value: '',
          class: 'tel'
        },
        // {
        //   icon:Imaes.wechat,
        //   label:'微信',
        //   value:["13667895788","18845698969"],
        //   class:''
        // },
        {
          icon: Imaes.email,
          label: '邮箱',
          value: '',
          class: 'tel'
        }
      ]
    }
  }
}

</script>

<style lang="less" scoped>
.ch-box {
  >.ch-item {
    margin-top: 8px;
    display: flex;

    >.ch-icon {
      width: 24px;
    }

    >.ch-content {
      margin-left: 15px;
      flex: 1;

      >.ch-label {
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        line-height: 24px;
      }

      >.ch-value {
        color: #333333;
        font-size: 16px;

        >* {
          margin-top: 10px;
        }
      }

      >.tel {
        color: #fda742;
        font-size: 18px;
        font-weight: bold;
      }
    }
  }

  >.ch-item+.ch-item {
    margin-top: 23px;
  }
}

.ch-card-title {
  font-size: 20px;
}</style>